import { Line, ReelWinPosition } from '@cgs/data-access';
import { Container, SequenceAction } from '@cgs/wge';
import { SpinConfig } from '../../../../reels_engine/game_config/game_config';
import { ReelsSoundModel } from '../../../../reels_engine/reels_sound_model';
import {
  T_IconsSoundModelComponent,
  T_ILinesModelProvider,
  T_IWinLineStrategyProvider,
  T_LinesSceneObjectComponent,
} from '../../../../type_definitions';
import { IconsSoundModelComponent } from '../../icons_sound_model_component';
import { ILinesModelProvider } from '../../interfaces/i_lines_model_provider';
import { LinesSceneObjectComponent } from '../../lines_scene_object_component';
import { MorphingWinLineAction } from '../complex_win_line_actions/morphing_lines_action';
import { ShortWinLinesWithIconsAction } from '../complex_win_line_actions/short_win_lines_with_icons_action';
import { SpecialNWaysAction } from '../complex_win_line_actions/special_nways_action';
import { IWinLineStrategyProvider } from '../win_line_strategy_providers/i_win_line_strategy_provider';
import { MorphWinLineActionComponent } from './win_line_action_component';

export class CycledWinLineActionProvider extends MorphWinLineActionComponent {
  constructor(container: Container, repeatWinLineSound: boolean = true) {
    super(container, repeatWinLineSound);
    console.log('load ' + this.constructor.name);
    this._strategyProvider = container.resolve<IWinLineStrategyProvider>(
      T_IWinLineStrategyProvider
    );
  }

  public update(
    reelsSoundModel: ReelsSoundModel,
    winLines: Line[],
    viewReels: number[][],
    spinConfig: SpinConfig,
    winPositions: ReelWinPosition[]
  ): void {
    super.update(reelsSoundModel, winLines, viewReels, spinConfig, winPositions);

    const lineModel = this.container.resolve<ILinesModelProvider>(T_ILinesModelProvider).lineModel;
    const lineNode = this.container.resolve<LinesSceneObjectComponent>(
      T_LinesSceneObjectComponent
    ).linesSceneObject;
    const iconSoundModel = this.container.resolve<IconsSoundModelComponent>(
      T_IconsSoundModelComponent
    ).iconsSoundModel;

    const winLineAction = new MorphingWinLineAction(
      this.container,
      lineNode,
      lineModel,
      spinConfig,
      winLines,
      winPositions,
      iconSoundModel,
      reelsSoundModel,
      this.repeatWinLineSound
    );
    const shortWinLineAction = new SequenceAction([
      new ShortWinLinesWithIconsAction(
        this.container,
        lineNode,
        lineModel,
        spinConfig,
        winLines,
        winPositions,
        reelsSoundModel
      ) /*,
      _parleyProgressActivator
          ? _parleyProgressActivator.getActivateParleyProgressOnWinLinesAction()
          : new EmptyAction()*/,
    ]);
    const specialLineAction = new SpecialNWaysAction(
      this.container,
      winLines,
      spinConfig,
      winPositions
    );

    if (this._strategyProvider) {
      this.shortWinLineAction = this._strategyProvider
        .getShortWinLineStrategy()
        .applyStrategy(shortWinLineAction);
      this.winLineAction = new SequenceAction([
        this.shortWinLineAction,
        this._strategyProvider.getWinLineStrategy().applyStrategy(winLineAction),
      ]);
      this.specialLineAction = this._strategyProvider
        .getSpecialWinLineStrategy()
        .applyStrategy(specialLineAction);
    } else {
      this.winLineAction = new SequenceAction([shortWinLineAction, winLineAction]);
      this.shortWinLineAction = shortWinLineAction;
      this.specialLineAction = specialLineAction;
    }
  }
}
